export default "__VITE_ASSET__DIsIcc9k__"